<template>
	<form id="login_form" class="login-form" @submit.prevent.stop="submitForm(login)">
		<fancy-input type="email" id="email" v-model="login.email" label="Email Address" required="required"></fancy-input>
		<fancy-input type="password" id="password" v-model="login.password" label="Password" required="required"></fancy-input>

		<button type="submit" class="mdc-button mdc-button--raised mdc-button--primary" v-ripple>Login</button>

		<p><a @click="resetPassword(login)" title="Reset Password">Forgot password?</a></p>
	</form>
</template>

<script>
	import { mapGetters } from 'vuex'
	import FancyInput from '@/components/FancyInput'
	import TextField from '@/components/TextField'
	import Ripple from '@/directives/Ripple'

	// Dependencies
	export default {
		name: 'loginForm',
		props: {
			onSuccess: Function,
		},
		data: () => ({
			login: {},
			error: null,
		}),
		components: {
			TextField,
			FancyInput,
		},
		directives: {
			Ripple,
		},
		methods: {
			submitForm(data) {
				this.error = null
				this.$store.dispatch('loginUser', data)
					.then(res => {
						this.$emit('loginSuccess', data)
					})
					.catch(err => {
						this.$emit('loginFail', err)
					})
			},
			resetPassword(data) {
				if (!data.email) {
					return this.$dialog('Please enter your email address.', {
						cancelText: 'Close',
					})
				}

				this.error = null
				this.$store.dispatch('sendPasswordReset', data.email)
					.then(res => {
						this.$emit('resetSuccess', data)
					})
					.catch(err => {
						this.$emit('resetFail', err)
					})
			},
		},
		computed: {
			...mapGetters([
				'user',
			]),
		},
	}
</script>

<style scoped lang="scss">
	@import '@material/button/mdc-button';

	a {
		transition: color 250ms $easing-material;
		will-change: color;

		&:hover {
			color: color_('primary');
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/LoginForm.vue